let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bxIMJ")).then(() => parcelRequire('jbzx0'));